// In-app invite to the voice training page. Shown inside the User layout when
// the `wake_word_collection` feature is on for this user. "Not now" snoozes it
// for a week; the × or finishing a round hides it for good on this device.
import React, { useState } from 'react';
import './voiceTraining.css';

const SNOOZE_MS = 7 * 24 * 60 * 60 * 1000;

function read(k) {
  try {
    return localStorage.getItem(k);
  } catch {
    return null;
  }
}
function write(k, v) {
  try {
    localStorage.setItem(k, v);
  } catch {
    /* private mode */
  }
}

export function shouldShowVoiceInvite(now = Date.now()) {
  if (read('cpvt_invite_off') === '1') return false;
  if (Number(read('cpvt_rounds') || 0) > 0) return false; // already contributed here
  return now > Number(read('cpvt_invite_snooze') || 0);
}

export default function VoiceTrainingInvite() {
  const [open, setOpen] = useState(() => shouldShowVoiceInvite());
  if (!open) return null;

  const snooze = () => {
    write('cpvt_invite_snooze', String(Date.now() + SNOOZE_MS));
    setOpen(false);
  };
  const never = () => {
    write('cpvt_invite_off', '1');
    setOpen(false);
  };

  return (
    <div className="cpvt-invite" role="dialog" aria-labelledby="cpvt-invite-title">
      <button type="button" className="cpvt-invite-close" onClick={never} aria-label="Don’t show again">
        ×
      </button>
      <div className="cpvt-invite-head">
        <span className="cpvt-invite-icon" aria-hidden="true">
          <i className="fas fa-microphone" />
        </span>
        <h3 id="cpvt-invite-title" className="cpvt-invite-title">Help train “Hey Comprehend”</h3>
      </div>
      <p>
        Lend us your voice for 2 minutes so hands-free Comprehend works for everyone.
        No patient info, nothing to set up.
      </p>
      <div className="cpvt-invite-actions">
        <button type="button" onClick={snooze}>Not now</button>
        <a href="/User/audio/collection?ref=app" target="_blank" rel="noopener noreferrer" onClick={snooze}>
          Let’s do it
        </a>
      </div>
    </div>
  );
}
